import React, { useState } from 'react';

export const ExecuteHedge = ({ hedgeStrategy, onExecute }) => {
  const [isExecuting, setIsExecuting] = useState(false);
  const [executed, setExecuted] = useState(false);

  const handleExecute = async () => {
    setIsExecuting(true);
    try {
      await onExecute(hedgeStrategy);
      setExecuted(true);
    } catch (error) {
      console.error('Execution failed:', error);
    } finally {
      setIsExecuting(false);
    }
  };

  if (executed) {
    return (
      <div className="bg-green-600/20 border border-green-500 rounded-xl p-6 text-center">
        <div className="text-green-400 font-bold text-xl mb-2">
          ✅ Hedge Executed Successfully
        </div>
        <div className="text-gray-400">
          Your position is now protected. Monitor progress in the dashboard.
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={handleExecute}
      disabled={isExecuting}
      className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white py-4 rounded-xl font-bold text-xl transition-colors flex items-center justify-center"
    >
      {isExecuting ? (
        <>
          <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full mr-2"></div>
          Executing Hedge...
        </>
      ) : (
        `Execute Hedge - $${hedgeStrategy.cost.toFixed(2)}`
      )}
    </button>
  );
};
